import { Alert } from '@commenda/kakashi';

interface ExceedsHundredBannerProps {
  totalOwnershipPercent: number;
  percentScale: number;
}

// utility-warning-600. Inline because Tailwind's content scanner doesn't
// pick up class strings from `packages/ui` in the consuming app.
const WARNING_FG = '#B76806';

export const ExceedsHundredBanner = ({ totalOwnershipPercent, percentScale }: ExceedsHundredBannerProps) => {
  const totalPercent = totalOwnershipPercent / percentScale;
  if (totalPercent <= 100) return null;
  return (
    <Alert
      variant="warning"
      title={<span style={{ color: WARNING_FG }}>Ownership exceeds 100%</span>}
      description={
        <p
          style={{
            color: WARNING_FG,
            fontSize: 14,
            lineHeight: '20px',
            fontWeight: 400,
            margin: 0,
          }}
        >
          Total stakeholder ownership currently sums to {totalPercent.toFixed(2)}%. Review individual stakes to bring the total to 100% or below.
        </p>
      }
    />
  );
};
